import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'htx-skeleton',
  imports: [NgStyle],
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss'
})
export class SkeletonComponent {
  width = input<string>('100%');
  height = input<string>('1rem');
  lines = input<number>(1);
  gap = input<string>('0.5rem');
  borderRadius = input<string>('4px');

  lineArray = computed(() => Array.from({ length: this.lines() }));
}
